export const ZonesData = [
  {
    zone: "North Zone",
    states: [
      {
        _id: "65b0a4046de5a748fdaaa809",
        Unique_Id: "STATE290081",
        name: "Jammu and Kashmir",
        value: null,
        label: null,
        Search_Value: "Jammu and Kashmir",
        createdAt: "2024-04-16T07:35:41.094Z",
        updatedAt: "2024-04-18T19:11:51.372Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe367f",
        Unique_Id: "STATE123463",
        name: "Haryana",
        value: null,
        label: null,
        Search_Value: "Haryana",
        createdAt: "2024-04-16T07:35:41.017Z",
        updatedAt: "2024-04-18T19:11:09.514Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe368b",
        Unique_Id: "STATE123475",
        name: "Punjab",
        value: null,
        label: null,
        Search_Value: "Punjab",
        createdAt: "2024-04-16T07:35:40.673Z",
        updatedAt: "2024-07-01T10:22:04.532Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3698",
        Unique_Id: "STATE123488",
        name: "Delhi",
        value: null,
        label: null,
        Search_Value: "Delhi",
        createdAt: "2024-04-16T07:35:41.219Z",
        updatedAt: "2024-04-18T19:12:22.381Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3680",
        Unique_Id: "STATE123464",
        name: "Himachal Pradesh",
        value: null,
        label: null,
        Search_Value: "Himachal Pradesh",
        createdAt: "2024-04-16T07:35:41.109Z",
        updatedAt: "2024-04-18T19:11:55.049Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3691",
        Unique_Id: "STATE123481",
        name: "Uttar Pradesh",
        value: null,
        label: null,
        Search_Value: "Uttar Pradesh",
        createdAt: "2024-04-16T07:35:41.277Z",
        updatedAt: "2024-04-18T19:12:51.955Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3695",
        Unique_Id: "STATE123485",
        name: "Chandigarh",
        value: null,
        label: null,
        Search_Value: "Chandigarh",
        createdAt: "2024-04-16T07:35:41.123Z",
        updatedAt: "2024-04-18T19:12:00.480Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3692",
        Unique_Id: "STATE123482",
        name: "Uttarakhand",
        value: null,
        label: null,
        Search_Value: "Uttarakhand",
        createdAt: "2024-04-16T07:35:40.840Z",
        updatedAt: "2024-04-18T19:10:07.678Z",
      },
    ],
  },
  {
    zone: "South Zone",
    states: [
      {
        _id: "6486b3a59f49f96d5ffe3682",
        Unique_Id: "STATE123468",
        name: "Karnataka",
        value: null,
        label: null,
        Search_Value: "Karnataka",
        createdAt: "2024-04-16T07:35:41.205Z",
        updatedAt: "2024-04-18T19:12:18.155Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe368e",
        Unique_Id: "STATE123478",
        name: "Tamil Nadu",
        value: null,
        label: null,
        Search_Value: "Tamil Nadu",
        createdAt: "2024-04-16T07:35:40.987Z",
        updatedAt: "2024-04-18T19:10:58.080Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe368f",
        Unique_Id: "STATE123479",
        name: "Telangana",
        value: null,
        label: null,
        Search_Value: "Telangana",
        createdAt: "2024-04-16T07:35:41.191Z",
        updatedAt: "2024-04-18T19:12:14.463Z",
      },
      {
        _id: "661a68f08e521b03e3578bfb",
        Unique_Id: "STATE3239103",
        name: "Andhra Pradesh",
        value: null,
        label: null,
        Search_Value: "Andhra Pradesh",
        createdAt: "2024-04-16T07:35:41.358Z",
        updatedAt: "2024-05-10T10:34:00.953Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3683",
        Unique_Id: "STATE123467",
        name: "Kerala",
        value: null,
        label: null,
        Search_Value: "Kerala",
        createdAt: "2024-04-16T07:35:41.331Z",
        updatedAt: "2024-04-18T19:13:17.250Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3699",
        Unique_Id: "STATE123489",
        name: "Puducherry",
        value: null,
        label: null,
        Search_Value: "Puducherry",
        createdAt: "2024-04-16T07:35:41.033Z",
        updatedAt: "2024-04-18T19:11:13.453Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3694",
        Unique_Id: "STATE123484",
        name: "Andaman and Nicobar Islands",
        value: null,
        label: null,
        Search_Value: "Andaman and Nicobar Islands",
        createdAt: "2024-04-16T07:35:40.749Z",
        updatedAt: "2024-04-16T07:48:37.622Z",
      },
    ],
  },
  {
    zone: "East Zone",
    states: [
      {
        _id: "6486b3a59f49f96d5ffe367b",
        Unique_Id: "STATE123459",
        name: "Bihar",
        value: null,
        label: null,
        Search_Value: "Bihar",
        createdAt: "2024-04-16T07:35:40.733Z",
        updatedAt: "2024-04-18T19:09:51.788Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3681",
        Unique_Id: "STATE123465",
        name: "Jharkhand",
        value: null,
        label: null,
        Search_Value: "Jharkhand",
        createdAt: "2024-04-16T07:35:41.344Z",
        updatedAt: "2024-04-18T19:13:22.073Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe368a",
        Unique_Id: "STATE123474",
        name: "Odisha",
        value: null,
        label: null,
        Search_Value: "Odisha",
        createdAt: "2024-04-16T07:35:40.901Z",
        updatedAt: "2024-04-18T19:10:47.786Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3683",
        Unique_Id: "STATE123467",
        name: "West Bengal",
        value: null,
        label: null,
        Search_Value: "West Bengal",
        createdAt: "2024-04-16T07:35:41.765Z",
        updatedAt: "2024-04-18T19:13:17.250Z",
      },
    ],
  },
  {
    zone: "West Zone",
    states: [
      {
        _id: "6486b3a59f49f96d5ffe368c",
        Unique_Id: "STATE123476",
        name: "Rajasthan",
        value: null,
        label: null,
        Search_Value: "Rajasthan",
        createdAt: "2024-04-16T07:35:41.063Z",
        updatedAt: "2024-04-18T19:11:42.952Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3684",
        Unique_Id: "STATE123468",
        name: "Madhya Pradesh",
        value: null,
        label: null,
        Search_Value: "Madhya Pradesh",
        createdAt: "2024-04-16T07:35:40.885Z",
        updatedAt: "2024-04-18T19:10:41.419Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3685",
        Unique_Id: "STATE123469",
        name: "Maharashtra",
        value: null,
        label: null,
        Search_Value: "Maharashtra",
        createdAt: "2024-04-16T07:35:40.870Z",
        updatedAt: "2024-04-18T19:10:13.667Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe367e",
        Unique_Id: "STATE123462",
        name: "Gujarat",
        value: null,
        label: null,
        Search_Value: "Gujarat",
        createdAt: "2024-04-16T07:35:41.291Z",
        updatedAt: "2024-04-18T19:12:57.246Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe367d",
        Unique_Id: "STATE123461",
        name: "Goa",
        value: null,
        label: null,
        Search_Value: "Goa",
        createdAt: "2024-04-16T07:35:41.318Z",
        updatedAt: "2024-04-18T19:13:13.081Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3696",
        Unique_Id: "STATE123486",
        name: "Dadra and Nagar Haveli and Daman and Diu",
        value: null,
        label: null,
        Search_Value: "Dadra and Nagar Haveli and Daman and Diu",
        createdAt: "2024-04-16T07:35:40.783Z",
        updatedAt: "2024-04-16T07:48:37.622Z",
      },
    ],
  },
  {
    zone: "North-East Zone",
    states: [
      {
        _id: "6486b3a59f49f96d5ffe367a",
        Unique_Id: "STATE123458",
        name: "Assam",
        value: null,
        label: null,
        Search_Value: "Assam",
        createdAt: "2024-04-16T07:35:41.048Z",
        updatedAt: "2024-04-18T19:11:17.073Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3679",
        Unique_Id: "STATE123457",
        name: "Arunachal Pradesh",
        value: null,
        label: null,
        Search_Value: "Arunachal Pradesh",
        createdAt: "2024-04-16T07:35:41.078Z",
        updatedAt: "2024-04-18T19:11:47.398Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3687",
        Unique_Id: "STATE123471",
        name: "Meghalaya",
        value: null,
        label: null,
        Search_Value: "Meghalaya",
        createdAt: "2024-04-16T07:35:41.262Z",
        updatedAt: "2024-04-18T19:12:34.602Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3686",
        Unique_Id: "STATE123470",
        name: "Manipur",
        value: null,
        label: null,
        Search_Value: "Manipur",
        createdAt: "2024-04-16T07:35:41.172Z",
        updatedAt: "2024-04-18T19:12:09.312Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3690",
        Unique_Id: "STATE123480",
        name: "Tripura",
        value: null,
        label: null,
        Search_Value: "Tripura",
        createdAt: "2024-04-16T07:35:40.797Z",
        updatedAt: "2024-04-18T19:10:03.262Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3689",
        Unique_Id: "STATE123473",
        name: "Nagaland",
        value: null,
        label: null,
        Search_Value: "Nagaland",
        createdAt: "2024-04-16T07:35:40.717Z",
        updatedAt: "2024-04-18T19:09:46.123Z",
      },
      {
        _id: "6486b3a59f49f96d5ffe3688",
        Unique_Id: "STATE123472",
        name: "Mizoram",
        value: null,
        label: null,
        Search_Value: "Mizoram",
        createdAt: "2024-04-16T07:35:41.304Z",
        updatedAt: "2024-04-18T19:13:07.675Z",
      },
    ],
  },
];